import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  padding: 50px;
`;

export const Items = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;

  div {
    display: flex;
    flex-direction: column;
    align-items: center;

    label {
      opacity: 0.4;
      margin-top: 10px;
    }
  }
`;
